import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';






import { NavbarModule } from 'app/layout/components/navbar/navbar.module';

import { ToolbarModule } from 'app/layout/components/toolbar/toolbar.module';

import { VerticalLayout3Component } from 'app/layout/vertical/layout-3/layout-3.component';

@NgModule({
    imports: [
    RouterModule,
    NavbarModule,
    ToolbarModule,
    VerticalLayout3Component
],
    exports: [
        VerticalLayout3Component
    ]
})
export class VerticalLayout3Module
{
}
